import GradeAPI from '@/apis/business/common/grade-api.js'

export default {
  namespaced: true,
  state: {
    grades: [],

    grade: null
  },

  getters: {
    getGrades (state) {
      return state.grades
    },

    getGrade (state) {
      return state.grade
    }
  },

  mutations: {
    setGrades (state, grades) {
      state.grades = grades
    },
    setGrade (state, gradeID) {
      state.grade = state.grades.find(grade => {
        return gradeID === grade.GradeID
      })
    }
  },

  actions: {
    // getGrade (context, gradeID) {
    //   context.commit('setGrade', gradeID)
    //   const result = context.getters.getClassRoom
    //   return new Promise((resolve, reject) => {
    //     resolve(!!result)
    //   })
    // },

    getGrades (context, params) {
      return new Promise((resolve, reject) => {
        GradeAPI.getAsync('', params).then(res => {
          context.commit('setGrades', res.Data.PageData)
          resolve(true)
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}
